import $ from "jquery";
import "datatables.net";
import "datatables.net-rowreorder-dt";
import 'bootstrap-icons/font/bootstrap-icons.css';
import bootbox from 'bootbox';
import { showMessage, initTinymce } from "./main";
import { Dropzone } from 'dropzone';
import "dropzone/dist/dropzone.css";
var dataTable;
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "productDetail")
        return;
    init();
    initDataTable();
    initProductImageDelete();
    initProductImageSaveOrder();
    initDropzone();
});
function initDropzone() {
    var id = $('#Id').val();
    var dropzone = new Dropzone("#my-dropzone", {
        url: "/Product/UploadImage",
        paramName: "file",
        maxFilesize: 25,
        acceptedFiles: ".jpg,.png",
        addRemoveLinks: true,
        dictDefaultMessage: "Sem presuňte súbory na nahranie, alebo kliknite", // Lokalizovaný text
        init: function () {
            this.on("sending", function (file, xhr, formData) {
                formData.append("id", id); // Pridanie extra parametra
            });
            // Event, keď všetky uploady skončia (úspešné aj neúspešné)
            this.on("queuecomplete", function () {
                this.removeAllFiles(); // Vymazanie všetkých nahraných súborov z Dropzone
                var productId = id;
                initializeProductImageOrder(productId);
                loadProductImageList();
                $("#uploadModal").modal("toggle");
                showMessage("Fotografie boli úspešne nahrané", "Zuba - nahranie fotografií");
            });
            // Alternatívne: Vymazať iba po úspešných uploadoch
            this.on("successmultiple", function () {
                this.removeAllFiles();
            });
            // Event pri chybe pri nahrávaní konkrétneho súboru
            this.on("error", function (file, errorMessage) {
                console.error("❌ Chyba pri nahrávaní súboru:", errorMessage);
                showMessage("Chyba pri nahrávaní!", "Zuba - nahranie fotografií");
            });
        }
    });
}
function initDataTable() {
    dataTable = $('#tableProductImage').DataTable({
        rowReorder: {
            enable: true,
            selector: 'td:first-child'
        },
        ordering: true,
        columnDefs: [
            {
                target: 0,
                visible: false,
                searchable: false
            },
            {
                target: 1,
                visible: false
            },
            { 'orderable': false, 'targets': [2, 3, 4] }
        ],
        language: {
            info: 'Strana _PAGE_ z _PAGES_',
            infoEmpty: 'Žiadne údaje',
            infoFiltered: '(filtrované z _MAX_ celkových záznamov)',
            lengthMenu: 'Zobraziť _MENU_ záznamov na stránku',
            zeroRecords: 'Nič sa nenašlo',
            search: 'Hľadať:'
        }
    });
}
function initializeProductImageOrder(productID) {
    var request = $.ajax({
        type: 'POST',
        url: '/Product/InitializeProductImageOrder/' + productID,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });
    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message, "Chyba!");
        }
    });
    request.fail(function (jqXHR) {
        console.error(jqXHR);
    });
}
function loadProductImageList() {
    var id = $("#Id").val();
    var request = $.ajax({
        type: 'GET',
        url: '/Product/ImageList/' + id,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });
    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message, "Chyba!");
        }
        else {
            $("#productImageList").html(res.html);
            initDataTable();
            initProductImageDelete();
        }
    });
    request.fail(function (jqXHR) {
        console.error(jqXHR);
    });
}
function initProductImageSaveOrder() {
    $("#btnSaveOrderProductImage").on('click', function () {
        var data = dataTable.rows({ order: 'applied' }).data();
        var ids = [];
        data.each(function (value, index) {
            ids.push(value[1]);
        });
        var formData = {
            ids: ids
        };
        var request = $.ajax({
            type: 'Post',
            url: '/Product/SaveProductImageOrder/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });
        request.done(function (res) {
            if (res.error == true) {
                showMessage(res.message, "Chyba!");
            }
            else {
                showMessage(res.message);
            }
        });
        request.fail(function (jqXHR) {
            console.error(jqXHR);
        });
    });
}
function init() {
    initTinymce('Description', 300);
    initTinymce('Definition', 600);
}
function initProductImageDelete() {
    $("#tableProductImage tbody").off('click', '.delete');
    $('#tableProductImage tbody').on('click', '.delete', function () {
        var id = $(this).data("id");
        bootbox.confirm('Naozaj chcete zmazať fotku?', function (result) {
            if (result == true) {
                deleteProductImage(id);
            }
        });
    });
}
function deleteProductImage(id) {
    var request = $.ajax({
        type: 'Post',
        url: '/Product/DeleteProductImage/' + id,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });
    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message);
        }
        else {
            var row = dataTable.row('#tr_' + id);
            row.remove().draw();
        }
    });
    request.fail(function (jqXHR) {
        console.error(jqXHR);
    });
}
//# sourceMappingURL=productDetail.js.map